import { Button, Modal, Text } from 'components'

import { usePostResetPassword } from 'services/auth'
import { useForm } from 'react-hook-form'
import { TextField } from 'uikit'

import { Loader } from '../../components'

import styles from './styles.module.scss'
import { useRef } from 'react'
import { useToast } from 'shared/hooks'

const ResetPassword = () => {
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  const {
    register,
    watch,
    handleSubmit,
    formState: { isDirty },
  } = useForm<{ email: string }>({
    mode: 'onChange',
    defaultValues: {
      email: '',
    },
  })

  const { mutate, isLoading } = usePostResetPassword()

  const { addToast } = useToast()

  const onSubmit = () => {
    mutate(
      { email: watch('email') },
      {
        onSuccess: () => {
          addToast({
            message: 'Email de recuperação de senha enviado com sucesso.',
          })

          closeButtonRef?.current?.click()
        },
        onError: () => {
          addToast({
            message:
              'Erro ao enviar email de recuperação de senha. Tente novamente.',
            type: 'alert',
          })
        },
      },
    )
  }

  return (
    <>
      {isLoading && <Loader />}

      <Modal.Title>Recuperação de senha</Modal.Title>

      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.content}>
          <Text weight="regular">
            Digite seu e-mail para receber as instruções de redefinição de
            senha.
          </Text>

          <TextField {...register('email')} label="Email" />
        </div>

        <Modal.Footer>
          <Modal.Close>
            <Button type="button" appearance="tertiary" ref={closeButtonRef}>
              Cancelar
            </Button>
          </Modal.Close>

          <Button disabled={!isDirty} width={87} type="submit">
            Enviar
          </Button>
        </Modal.Footer>
      </form>
    </>
  )
}

export default ResetPassword
